
import React from 'react'
import newApplication from '../../../../images/rewampimages/Frame 13.png';
import repeatApplication from '../../../../images/rewampimages/Frame 13 (1).png';
import assignedtoCS from '../../../../images/rewampimages/Frame 13 (2).png';
import assignedtoCF from '../../../../images/rewampimages/Frame 13 (3).png';
import assignedtooperation from '../../../../images/rewampimages/Frame 13 (4).png';
import analysis_chart from '../../../../images/rewampimages/analysis-chart.png';
import Ops from '../../../../images/rewampimages/Vector (26).png';
import ReactApexChart from 'react-apexcharts';
import { CASHBRIDGE_LIKE, CHECK_COMPANY_TENANT, CREDFIN_LIKE } from '../../../../layouts/MainTenantconfig';

const HeadingTabsStyle = {
    display: 'flex',
    marginTop: '20px'
}
const SubTabsStyle = {
    width: 'calc(98.2% / 5)',
    // border:'2px solid #ECEEF6',
    minHeight: '130px',
    padding: '10px',
    margin: '30px 12px',
    borderRadius: '6px',
}

const customBoxShadowcard = {
    boxShadow: '5px 5px 10px 4px #cecbcb',
    borderRadius: '6px',
    background: '#fff'
}

const TablePadding = {
    padding: '20px'
}

const DashboardUi = ({ chartOptions, mainId, tabledata, emailIdToShow, downloadBydepartmentFunction, datadownload, departmentToSend, admin, todaysApplicationNo, userStatusData, performanceData, leadDashFilterData, filterDataChange, filterDataHandler, performanceLoader,
    stateWiseData, agentWiseData, statusWiseData, errorMsg, todayData, agentStatusWiseData, graphState, statusWiseReportingHandler, ReportViewState }) => (
    <>
        <div className='container-fluid lm-dashboard'>
            <div className='row' style={{ marginLeft: '-7px' }}>
                <div className='col-sm-2 col-xs-2' style={{ marginTop: '20px' }}>
                    <label className="font-12px">From</label>
                    <input onChange={(e) => filterDataChange(e, "startDate")} value={leadDashFilterData.startDateToShow} className='date-input-lm' type='date' style={{ background: '#fff' }} />
                </div>
                <div className='col-sm-2 col-xs-2' style={{ marginTop: '20px' }}>
                    <label className="font-12px"> To</label>

                    <input onChange={(e) => filterDataChange(e, "endDate")} value={leadDashFilterData.endDateToShow} className='date-input-lm' type='date' style={{ background: '#fff' }} />
                </div>
                <div className="col-xs-12 col-sm-1" style={{ marginTop: '20px' }}>
                    <button className="reset-btn" style={{ padding: '10px', marginTop: '22px' }} onClick={e => filterDataHandler()}>
                        Filter
                    </button>
                </div>
            </div>
            {/* {todayData ?
                <ul className='lm-card-main lm-card'>
                    <li><h5>New Application <img src={newApplication} width={'35px'} style={{ float: 'right', marginTop: '-10px' }} /></h5>
                        <h2><b>{todaysApplicationNo.newUserCount}</b></h2>
                    </li>
                    <li><h5>Repeat Application <img src={repeatApplication} width={'35px'} style={{ float: 'right', marginTop: '-10px' }} /></h5>
                        <h2><b>{todaysApplicationNo.repeatUserCount}</b></h2>
                    </li>
                    <li><h5>Assigned to<br />
                        Credit/Finance  <img src={assignedtoCS} width={'35px'} style={{ float: 'right', marginTop: '-25px' }} /></h5>
                        {todayData && todayData != "" ? <h2><b>{todayData['Finance / Credit']}</b></h2> : ""}</li>
                    <li><h5>Assigned to <br />
                        Customer Service  <img src={assignedtoCF} width={'35px'} style={{ float: 'right', marginTop: '-25px' }} /></h5>
                        {todayData && todayData != "" ? <h2><b>{todayData['Customer Service']}</b></h2> : ""}</li>


                    <li><h5>Assigned to <br />
                        Operations  <img src={assignedtooperation} width={'35px'} style={{ float: 'right', marginTop: '-25px' }} /></h5>
                        <h2><b>{todayData.Legal}</b></h2>
                    </li>
                </ul>
                : ""} */}

            {todayData ?
                <div className='HeadingTabs' style={HeadingTabsStyle}>
                    <div className="Subtabs" style={{ ...SubTabsStyle, background: 'rgb(255, 226, 230)', boxShadow: 'rgb(249 190 198) 4px 4px 0px 2px', marginLeft: '0' }}>
                        <h5 style={{ fontWeight: '600' }}>New Application <img src={newApplication} width={'35px'} style={{ float: 'right', marginTop: '-10px', mixBlendMode: 'multiply' }} /></h5>
                        <h2><b>{todaysApplicationNo.newUserCount}</b></h2>
                    </div>
                    <div className="Subtabs" style={{ ...SubTabsStyle, background: 'rgb(255, 244, 222)', boxShadow: 'rgb(243 218 168) 4px 4px 0px 2px' }}>
                        <h5 style={{ fontWeight: '600' }}>Repeat Application <img src={repeatApplication} width={'35px'} style={{ float: 'right', marginTop: '-10px', mixBlendMode: 'multiply' }} /></h5>
                        <h2><b>{todaysApplicationNo.repeatUserCount}</b></h2>
                    </div>
                    <div className="Subtabs" style={{ ...SubTabsStyle, background: 'rgb(255, 241, 193)', boxShadow: 'rgb(239 211 114) 4px 4px 0px 2px' }}>
                        <h5 style={{ fontWeight: '600' }}>Assigned to<br />
                            Credit/Finance  <img src={assignedtoCS} width={'35px'} style={{ float: 'right', marginTop: '-25px', mixBlendMode: 'multiply' }} /></h5>
                        {todayData && todayData != "" ? <h2><b>{todayData['Finance / Credit']}</b></h2> : ""}
                    </div>
                    <div className="Subtabs" style={{ ...SubTabsStyle, background: 'rgb(220, 252, 231)', boxShadow: 'rgb(139 211 164) 4px 4px 0px 2px' }}>
                        <h5 style={{ fontWeight: '600' }}>Assigned to <br />
                            Customer Service  <img src={assignedtoCF} width={'35px'} style={{ float: 'right', marginTop: '-25px', mixBlendMode: 'multiply' }} /></h5>
                        {todayData && todayData != "" ? <h2><b>{todayData['Customer Service']}</b></h2> : ""}
                    </div>
                    <div className="Subtabs" style={{ ...SubTabsStyle, background: 'rgb(244, 232, 255)', boxShadow: 'rgb(175 133 213) 4px 4px 0px 2px', marginRight: '0' }}>
                        <h5 style={{ fontWeight: '600' }}>Assigned to <br />
                            Operations  <img src={assignedtooperation} width={'35px'} style={{ float: 'right', marginTop: '-25px', mixBlendMode: 'multiply' }} /></h5>
                        <h2><b>{todayData.Legal}</b></h2>
                    </div>
                </div>
                : ''}
            {/* <div className='lm-second-card'> */}

            <div className='row' style={{ marginBottom: '30px', marginTop: '20px' }}>
                <div className='col-sm-6 col-xs-12'>
                    <div style={{ ...customBoxShadowcard, padding: '10px' }}>
                        <h5 style={{ marginLeft: '10px' }}><b><img src={analysis_chart} width={'20px'} />&nbsp;&nbsp;Operation Analysis</b></h5>
                        <div className='' style={{ marginTop: '40px' }}>
                            <ReactApexChart options={chartOptions} series={chartOptions.series} type="donut" height={admin.department === 'Customer Service' ? 392 : admin.department === 'Finance / Credit' ? 332 : admin.department === 'Legal' ? 272 : 350} width="100%" />
                        </div>
                    </div>
                </div>
                {admin && admin.department === 'Legal' ?
                    <div className='col-sm-6 col-xs-12'>
                        <div style={{ ...customBoxShadowcard, padding: '10px' }}>
                            <h5 style={{}}><b><img src={Ops} width={'20x'} />&nbsp;&nbsp; Analysis Table</b></h5>
                            <table class="lm-dashboard  tableFirst" style={{ width: '100%' }}>
                                <tbody>

                                    <tr>
                                        <th style={{ ...TablePadding, borderTopLeftRadius: '5px' }} >Employee ID</th>
                                        <td style={{ ...TablePadding, borderTopLeftRadius: '5px' }}>{admin && admin.emailId ? admin.emailId : ''}</td>
                                    </tr>
                                    <tr>
                                        <th style={TablePadding}>Total Assigned</th>
                                        <td style={TablePadding}>{tabledata.totalAssignmentDone}</td>
                                    </tr>
                                    <tr>
                                        <th style={TablePadding}>Mark RFD</th>
                                        <td style={TablePadding}>{tabledata.markAsRfd}</td>
                                    </tr>
                                    <tr>
                                        <th style={TablePadding}>Expired</th>
                                        <td style={TablePadding}>{tabledata.expired}</td>

                                    </tr>
                                    <tr >
                                        <th style={{ ...TablePadding, borderBottom: 'none', borderBottomLeftRadius: '5px' }}>Pending</th>
                                        <td style={{ ...TablePadding, borderBottom: 'none', borderBottomRightRadius: '5px' }}>{tabledata.totalPending}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                    : ""}
                {admin && admin.department === 'Customer Service' ?
                    <div className='col-sm-6 col-xs-12'>
                        <div style={{ ...customBoxShadowcard, padding: '10px' }}>
                            <h5 style={{}}><b><img src={Ops} width={'20x'} />&nbsp;&nbsp; Analysis Table</b></h5>
                            <table class="lm-dashboard  tableFirst" style={{ width: '100%' }}>
                                <tbody>

                                    <tr>
                                        <th style={{ ...TablePadding, borderTopLeftRadius: '5px' }} >Employee ID</th>
                                        <td style={{ ...TablePadding, borderTopLeftRadius: '5px' }}>{admin && admin.emailId ? admin.emailId : ''}</td>
                                    </tr>
                                    <tr>
                                        <th style={TablePadding}>Approved</th>
                                        <td style={TablePadding}>{tabledata.approved}</td>
                                    </tr>
                                    <tr>
                                        <th style={TablePadding}>Communicated</th>
                                        <td style={TablePadding}>{tabledata.communicated}</td>
                                    </tr>
                                    <tr>
                                        <th style={TablePadding}>Mark As Complete</th>
                                        <td style={TablePadding}>{tabledata.markAsComplete}</td>

                                    </tr>
                                    {
                                        CHECK_COMPANY_TENANT(CREDFIN_LIKE) || CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ?
                                            <tr>
                                                <th style={TablePadding}>Mark As Completed Today</th>
                                                <td style={TablePadding}>{tabledata.validCompletedLeadCount}</td>

                                            </tr>
                                            : ""}
                                    <tr >
                                        <th style={TablePadding}>Rejected</th>
                                        <td style={TablePadding}>{tabledata.rejected}</td>
                                    </tr>
                                    <tr >
                                        <th style={TablePadding}>Total Assignment Done</th>
                                        <td style={TablePadding}>{tabledata.totalAssignmentDone}</td>
                                    </tr>
                                    <tr >
                                        <th style={TablePadding}>Loan Under Process</th>
                                        <td style={TablePadding}>{tabledata.lup}</td>
                                    </tr>
                                    <tr >
                                        <th style={{ ...TablePadding, borderBottom: 'none', borderBottomLeftRadius: '5px' }}>Total Pending</th>
                                        <td style={{ ...TablePadding, borderBottom: 'none', borderBottomRightRadius: '5px' }}>{tabledata.totalPending}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    : ""}
                {admin && admin.department === 'Finance / Credit' ?
                    <div className='col-sm-6 col-xs-12'>
                        <div style={{ ...customBoxShadowcard, padding: '10px' }}>
                            <h5 style={{}}><b><img src={Ops} width={'20x'} />&nbsp;&nbsp; Analysis Table</b></h5>
                            <table class="lm-dashboard  tableFirst" style={{ width: '100%' }}>
                                <tbody>

                                    <tr>
                                        <th style={{ ...TablePadding, borderTopLeftRadius: '5px' }} >Employee ID</th>
                                        <td style={{ ...TablePadding, borderTopLeftRadius: '5px' }}>{admin && admin.emailId ? admin.emailId : ''}</td>
                                    </tr>
                                    <tr>
                                        <th style={TablePadding}>Approved</th>
                                        <td style={TablePadding}>{tabledata.approved}</td>
                                    </tr>
                                    <tr>
                                        <th style={TablePadding}>Expired</th>
                                        <td style={TablePadding}>{tabledata.expired}</td>
                                    </tr>

                                    <tr>
                                        <th style={TablePadding}>Rejected</th>
                                        <td style={TablePadding}>{tabledata.rejected}</td>
                                    </tr>
                                    {
                                         CHECK_COMPANY_TENANT(CREDFIN_LIKE) || CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE)?
                                         <tr>
                                        <th style={TablePadding}>Hold</th>
                                        <td style={TablePadding}>{tabledata?.hold}</td>
                                    </tr>
                                    :""}
                                    <tr>
                                        <th style={TablePadding}>Total Assignment Done</th>
                                        <td style={TablePadding}>{tabledata.totalAssignmentDone}</td>
                                    </tr>
                                    <tr>
                                        <th style={{ ...TablePadding, borderBottom: 'none', borderBottomLeftRadius: '5px' }}>Total Pending</th>
                                        <td style={{ ...TablePadding, borderBottom: 'none', borderBottomRightRadius: '5px' }}>{tabledata.totalPending}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    : ""}
            </div>
            {/* </div> */}
        </div>
    </>
)
export default DashboardUi
